import { render } from "./InputView.vue?vue&type=template&id=2edc172a&scoped=true"
import script from "./InputView.vue?vue&type=script&lang=js"
export * from "./InputView.vue?vue&type=script&lang=js"

import "./InputView.vue?vue&type=style&index=0&id=2edc172a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edc172a"]])

export default __exports__